export const LICENSE_SUBJECTS = {
  enterprise: "/license/enterprise",
  archive: "/license/enterprise/archive",
  auditlog: "/license/enterprise/auditlog",
  illuminate: "/license/enterprise/illuminate",
  searchFilter: "/license/enterprise/search-filter",
  customization: "/license/enterprise/customization",
  views: "/license/enterprise/views",
  forwarder: "/license/enterprise/forwarder",
  report: "/license/enterprise/report",
  security: "/license/security",
  anomaly: "/license/anomaly"
};
export const LICENSE_TYPES = {
  "/license/enterprise": "Graylog Enterprise",
  "/license/enterprise/customization": "Graylog Enterprise (Customization)",
  "/license/enterprise/archive": "Graylog Enterprise (Archiving)",
  "/license/enterprise/auditlog": "Graylog Enterprise (Audit Log)",
  "/license/enterprise/illuminate": "Graylog Enterprise (Illuminate)",
  "/license/enterprise/report": "Graylog Enterprise (Reporting)",
  "/license/enterprise/search-filter": "Graylog Enterprise (Search Filter)",
  "/license/enterprise/views": "Graylog Enterprise (Views)",
  "/license/enterprise/forwarder": "Graylog Enterprise (Forwarder)",
  "/license/security": "Graylog Security",
  "/license/anomaly": "Graylog Anomaly Detection"
};
export const LICENSE_TYPE = {
  drawDown: "Draw-Down",
  dailyUsage: "Daily Usage"
};
export const LICENSE_STATUS = {
  active: "ACTIVE",
  queued: "QUEUED",
  expired: "EXPIRED",
  inactive: "INACTIVE"
};
export const DRAWDOWN_PRODUCTS = {
  enterprise: "Enterprise",
  security: "Security",
  anomaly: "Anomaly",
  volume: "Volume"
};
export const DRAWDOWN_PRODUCTS_NAMES = {
  Enterprise: "Graylog Enterprise",
  Security: "Graylog Security",
  Anomaly: "Graylog Anomaly Detection",
  Volume: void 0
};
